export var OpenCollapseModifierGroupEnum;
(function (OpenCollapseModifierGroupEnum) {
    OpenCollapseModifierGroupEnum["ALL"] = "ALL";
    OpenCollapseModifierGroupEnum["NONE"] = "NONE";
    OpenCollapseModifierGroupEnum["REQUIRED"] = "REQUIRED";
})(OpenCollapseModifierGroupEnum || (OpenCollapseModifierGroupEnum = {}));
//# sourceMappingURL=open-collapse-modifier-group.enum.js.map